module.exports = __webpack_public_path__ + "img/saas_icon.54cfcab3.png";